import styled, { css } from 'styled-components';

import MaterialIcon from '@/components/atom/MaterialIcon';
import theme from '@/styles/theme';

interface Props<T> {
  title: string;
  list: T[];
  onClick: (item: T) => void;
  getItemName: (item: T) => string;
  selectedItem: T;
}
const NonBenefitFilterModal = <T extends { id: string }>(props: Props<T>) => {
  const { title, list, selectedItem, onClick, getItemName } = props;
  return (
    <FilterModalWrapper>
      <FilterModalTitle>{title}</FilterModalTitle>
      <FilterList>
        {list.map((item) => (
          <Filter key={`filter-${getItemName(item)}`} onClick={() => onClick(item)}>
            <p>{getItemName(item)}</p>
            {selectedItem.id === item.id && <MaterialIcon name='check' size={32} color={theme.color.primary500} />}
          </Filter>
        ))}
      </FilterList>
    </FilterModalWrapper>
  );
};

export default NonBenefitFilterModal;

const FilterModalWrapper = styled.div`
  ${({ theme }) => css`
    width: ${theme.client.isMobile ? 300 : 560}px;
    background-color: ${theme.color.white};
  `}
  border-radius:24px;
  padding: 24px 0 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FilterModalTitle = styled.p`
  ${({ theme }) => css`
    ${theme.typography.UI20SB}
    color: ${theme.color.gray800};
    padding: 0 24px;
  `}
`;

const FilterList = styled.ul``;

const Filter = styled.li`
  ${({ theme }) => css`
    & > p {
      ${theme.typography.UI16SB}
      color: ${theme.color.gray700};
    }
  `}
  height: 56px;
  padding: 12px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;
